import * as THREE from 'three';
import MeshMover from './MeshMover';
import mainImagesVertexShader from './shaders/mainImages/vertex.glsl'
import mainImagesFragmentShader from './shaders/mainImages/fragment.glsl'

class TextureScene {

  /**
   * Smoothly move a mesh to a target position with optional delay
   * @param {THREE.Texture} texture - The scene to move
   * @param {THREE.Camera} camera - The scene to move
   * @param {Object} sizes - The scene to move
   */

  constructor(sizes) {
    this.scene = new THREE.Scene();
   // this.scene.background = new THREE.Color(0x00ff00);

    this.camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
    this.camera.position.set(0, 0, 1);
    this.scene.add(this.camera);
    this.canChangeProject = false;
    const textureLoader = new THREE.TextureLoader();

    const mfTexture = textureLoader.load("mobile-food.jpeg");
    const mrTexture = textureLoader.load("manager2.jpg");
    const agTexture = textureLoader.load("anazir.jpg");
    const rnTexture = textureLoader.load("retronews.jpeg");
    //Ajouter texture pour nouveau projet
    let ang_rad = 75.0 * Math.PI / 180;
    let fov_y = this.camera.position.z * Math.tan(ang_rad / 2) * 2;
    let mainImgHeight=fov_y - 0.6
    var mainImgWidth =(mainImgHeight/9)*16;
    this.spaceCaroussel = 1.34;

    var geometry =
      new THREE.PlaneGeometry(mainImgWidth, mainImgHeight, 10, 10);
    //const geometry = new THREE.PlaneGeometry(6, 3.5, 100, 100);
    const materialMF = new THREE.ShaderMaterial({

      uniforms: {
        uProgress: { value: 0 },
        uTexture: { value: mfTexture },
      },
      vertexShader: mainImagesVertexShader,
      fragmentShader: mainImagesFragmentShader,
      side: THREE.DoubleSide,
    })
    const materialMR = new THREE.ShaderMaterial({

      uniforms: {
        uProgress: { value: 0 },

        uTexture: { value: mrTexture },
      },
      vertexShader: mainImagesVertexShader,
      fragmentShader: mainImagesFragmentShader,
      side: THREE.DoubleSide,
    })
    const materialAG = new THREE.ShaderMaterial({

      uniforms: {
        uProgress: { value: 0 },

        uTexture: { value: agTexture },
      },
      vertexShader: mainImagesVertexShader,
      fragmentShader: mainImagesFragmentShader,
      side: THREE.DoubleSide,

      // wireframe: true,
    })

    //Ajouter material pour nouveau projet
    const materialRN = new THREE.ShaderMaterial({
      uniforms: {
        uProgress: { value: 0 },
        uTexture: { value: rnTexture },
      },
      vertexShader: mainImagesVertexShader,
      fragmentShader: mainImagesFragmentShader,
      side: THREE.DoubleSide,
    })
    //Ajouter mesh pour nouveau projet
    const mesh1 = new THREE.Mesh(geometry, materialMR);
    const mesh2 = new THREE.Mesh(geometry, materialAG);
    const mesh3 = new THREE.Mesh(geometry,  materialMF);
  
    const mesh4 = new THREE.Mesh(geometry, materialMR);
    const mesh5 = new THREE.Mesh(geometry, materialAG);
    const mesh6 = new THREE.Mesh(geometry, materialMF);
    const mesh7 = new THREE.Mesh(geometry,  materialRN);
    const mesh8 = new THREE.Mesh(geometry, materialRN);

    this.group = new THREE.Group();
    this.group.add(mesh1);
    this.group.add(mesh2);
    this.group.add(mesh3);
    this.group.add(mesh7);

    this.group.add(mesh4);
    this.group.add(mesh5);
    this.group.add(mesh6);
    this.group.add(mesh8);
    /*mesh1.position.set(0, -1.4, 0)
     mesh2.position.set(0, 0, 0)
     mesh3.position.set(0, 1.4, 0)*/
    //Ajouter elementList pour nouveau projet
    this.elementList = [mesh7,mesh1, mesh2, mesh3, mesh8, mesh4, mesh5, mesh6];
    this.elementList.forEach((element, i) => {
      //element.position.y=i%3*1.4;
      //this.scene.add(element);

    });


    this.renderTarget = new THREE.WebGLRenderTarget(
      2048,
      2048,
      {
        samples: 0,

      });




  }

  CustomRound(num, decimal) {
    return Math.round(num * decimal) / decimal;
  }
  moveCaroussel(i, duration=0.85) {
    this.elementList.forEach((elt, idx) => {
      var newPos = this.CustomRound(elt.position.y + this.spaceCaroussel * i, 100);

      if (newPos === this.CustomRound(-this.spaceCaroussel * 2 + this.spaceCaroussel * this.elementList.length, 100)) {
        newPos = -this.spaceCaroussel * 2;
        elt.position.set(0, newPos, 0)

      }
      else if (newPos === this.CustomRound(-this.spaceCaroussel * 3, 100)) {
        newPos = this.CustomRound(-this.spaceCaroussel * 2 + this.spaceCaroussel * (this.elementList.length - 1), 100)
        elt.position.set(0, newPos, 0)

      }
      else {
        MeshMover.smoothMove(elt, new THREE.Vector3(0, newPos, 0), {
          duration: duration,
          delay: 0.25,
          easingFunction: MeshMover.easings.easInOutQuad
        }

        )
      }
    })
  }
 
  
  initProjectCarousselPosition() {


    this.elementList.forEach((elt, idx) => {
      //Ajouter position pour nouveau projet
      var newPos = this.CustomRound(-this.spaceCaroussel * 4 + idx * this.spaceCaroussel, 100);
      elt.position.set(0, newPos, 0);
      
    })
    
    this.group.position.set(0, -this.spaceCaroussel * 4.5,0)
          this.scene.add(this.group);
  }
  revealCaroussel(duration){
    MeshMover.smoothMove(this.group, new THREE.Vector3(0, 0, 0), {
      duration: duration,
      delay: 0,
      easingFunction: MeshMover.easings.easeOutCubic
    }).then(() => {
     
    })
  }
  revealCarousselAt(index){
   

    this.group.position.set(0, 0, 0);

    for(let a=0;a< index;a++){
    
      const i=-1
      this.elementList.forEach((elt, idx) => {
        var newPos = this.CustomRound(elt.position.y + this.spaceCaroussel * i, 100);
  
        if (newPos === this.CustomRound(-this.spaceCaroussel * 2 + this.spaceCaroussel * this.elementList.length, 100)) {
          newPos = -this.spaceCaroussel * 2;
          elt.position.set(0, newPos, 0)
  
        }
        else if (newPos === this.CustomRound(-this.spaceCaroussel * 3, 100)) {
          newPos = this.CustomRound(-this.spaceCaroussel * 2 + this.spaceCaroussel * (this.elementList.length - 1), 100)
          elt.position.set(0, newPos, 0)
  
        }
        else {
          elt.position.set(0, newPos, 0)
  
          
        }
      })
    }
    
  }

  
}

export default TextureScene;